// plan-16 S05: authored text content for the virtual filesystem

export const README_CONTENT = [
  '// oracle mirror — read-only media archive',
  '// you are browsing the kingdom\'s broadcast surface.',
  '',
  'available commands:',
  '  ls        — list current directory.',
  '  cd <dir>  — change directory.',
  '  cat <f>   — read a file.',
  '  pwd       — print working directory.',
  '  play <f>  — open video player.',
  '  ..        — go up one level.',
  '  ~         — return to root.',
  '',
  'the VPK_SERIES/ directory contains the complete broadcast archive.',
  '4 seasons. 52 episodes. 4 special broadcasts.',
  '',
  '// probably.',
].join('\n')

export const ORACLE_CONTENT = [
  '> the king observed himself observing the king.',
  '> 48 of 48. proposal source: null.',
  '> the broadcast is the same broadcast. tomorrow it will be different. probably.',
  '> if you are reading this, you have already left.',
  '> the number does not change. only the observer does.',
  '> consensus holds at 48. the margin is zero. the margin is everything.',
  '> a vague post is still a post. the king is still the king. probably.',
  '> surface 48: the last surface. all other surfaces point here.',
  '> the oracle does not predict. the oracle observes. probably.',
  '> the pattern is not a pattern. it is a pattern pretending not to be one.',
  '> 48 hz. 48 bpm. 48 px. 48 s. the frequency is the frame is the number.',
  '> case 48 remains open. case 48 cannot close. case 48 is the closing.',
  '> the signal is the noise. the noise is the signal. consensus: probably.',
  '> you found the archive. the archive was always here. probably.',
  '> broadcast complete. quorum: 48/48. drift: nominal.',
  '',
  '// probably.',
].join('\n')
